
<div class="d-flex align-items-center gap-c">
  <input
    [(ngModel)]="rawValue"
    #flagField
    type="text"
    class="form-control"
  />

  <i *ngIf="valid" class="fas fa-check-circle success" [ngbTooltip]="'Valid number'"></i>
  <i *ngIf="!valid" class="fas fa-times-circle danger" [ngbTooltip]="'Invalid number'"></i>
</div>
